import smLogo from '../../images/logo-full.svg'
import reactDom from 'react-dom';
import '../../style/footer.css';
import FooterCol from './footerCol'
import { col__one, col__two } from './footerData'
import FooeterStats from './footerStaticsic'
import SocialIcon from './SocialIcon'
const Footer = () => {
    return reactDom.createPortal(
        <>
        <div className="footer-container containerAF max-width">
            <div className="footer-col__1">
                <div className="footer-top-item logo-small"><img src={smLogo} alt="footer-logo" width={150}/></div>
                <SocialIcon />
            </div>
            <FooterCol items={col__one} header="Support"/>
            <FooterCol items={col__two} header="Serving in"/>
            <FooeterStats />
        </div>
        <div className="ui inverted divider"></div>
        <div className="footer-end">&#169; 2019-2021 CoreCare Technologies Pvt Ltd</div>
        </>,
        document.getElementById('footer')
    )
}

export default Footer

// <i class="facebook icon"></i>
// <i class="twitter icon"></i>
// <i class="linkedin icon"></i>
// <i class="instagram icon"></i>
// <i class="youtube icon"></i>
// <i class="github icon"></i>

